import TopNav from "@/components/feature/TopNav";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import TopicsContent from "./components/TopicsContent";
import { useSeo } from "@/hooks/useSeo";
import { news } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];

const topicsJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "分类专题 - 黑料网爆",
    description: "按综艺现场、影视动态、音乐现场、品牌代言、网络热议与海外娱乐分类浏览全网热点爆料。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "/" },
      { "@type": "ListItem", position: 2, name: "分类专题", item: "/topics" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "爆料列表",
    itemListElement: allNews.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
      url: `/article/${item.id}`,
    })),
  },
];

export default function Topics() {
  useSeo({
    title: "分类专题 | 黑料网爆 - 综艺影视音乐热点分类浏览",
    description:
      "按栏目浏览黑料网爆的全部热点：综艺现场、影视动态、音乐现场、品牌代言、网络热议与海外娱乐，支持按热度与时间快速筛选今天的爆料。",
    keywords: "黑料网爆分类,综艺现场,影视动态,音乐现场,品牌代言,网络热议,海外娱乐",
    canonicalPath: "/topics",
    jsonLd: topicsJsonLd,
  });

  return (
    <>
      <TopNav />
      <main>
        <TopicsContent />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}